import { FC } from 'react'
import { InputTextType } from '../../../common/InputType'

type Props = {
  first: InputTextType
}

const OneInputText: FC<Props> = (props) => {
  const { first } = props

  return (
    <div className="switcher">
      <span>
        <label htmlFor={first.id} className="d-block">
          {first.icon && <first.icon className="me-1" />}
          {first.label && `${first.label}:`}
          {first.required && (
            <span className="text-light bg-danger badge ms-1">必須</span>
          )}
        </label>
        <input
          type={first.type}
          id={first.id}
          placeholder={first.placeholder}
          autoComplete={first.autoComplete}
          style={{ width: '100%' }}
          value={first.state}
          readOnly={first.readonly}
          maxLength={first.maxLength}
          onChange={(e) => first.setState(e.target.value)}
        />
      </span>
      <span></span>
      <span></span>
    </div>
  )
}

export default OneInputText
